import { PropsWithChildren } from 'react';

import { Stack, Text, TextLink } from '@eneco/sparky';
import { CheckIcon, ElectricityIcon, GasIcon } from '@eneco/sparky/icons';
import { styled } from '@eneco/sparky/stitches';
import { TextColors } from '@eneco/sparky/types';

export const inlineStrongReplacement = {
  strong: (props: PropsWithChildren) => (
    <Text weight={'bold'} display={'inline'}>
      {props.children}
    </Text>
  ),
};

const StyledParagraph = styled(Text, {
  marginBlockEnd: '1.5rem',
  '&:last-child': {
    marginBlockEnd: '0',
  },
});

export const inlineParagraphReplacement = {
  p: (props: PropsWithChildren) => <StyledParagraph as="p">{props.children}</StyledParagraph>,
};

export const inlineCheckmarkReplacement = {
  ul: (props: PropsWithChildren) => (
    <Stack as="ul" gap={1}>
      {props.children}
    </Stack>
  ),
  li: (props: PropsWithChildren) => (
    <Stack as="li" gap={2} direction={'row'}>
      <CheckIcon color={'feedbackSuccess'} />
      <span>{props.children}</span>
    </Stack>
  ),
};

type IconType = 'gas' | 'electricity';

export const iconReplacement = {
  icon: (props: PropsWithChildren & { type: IconType }) => {
    return (
      <>
        {props.type === 'electricity' && <ElectricityIcon color="iconElectricity" />}
        {props.type === 'gas' && <GasIcon color={'iconGas'} />}

        <span>{props.children}</span>
      </>
    );
  },
};

export const link = {
  a: ({
    href,
    children,
    color,
    target = '_blank',
  }: {
    href: string;
    children: string;
    color?: keyof TextColors | '';
    target?: string;
  }) => {
    return (
      <TextLink href={href} target={target} {...(color ? { color } : {})}>
        {children}
      </TextLink>
    );
  },
};
